import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardActionsContainer } from '../CardActionsContainer';
import { FillFormButtonMobile } from '../../components/FillFormButtonMobile';
import { isRenterFormEnabled } from '../../selectors/isRenterFormEnabled';
import { trackSafeRentFillFormClick } from './tracking';
import { selectRecommendationById } from '../../selectors/recommendations/selectRecommendationById';
import { useIsDailyrentOnlineBookingEnabled } from '../../hooks/useIsDailyrentOnlineBookingEnabled';
import { DailyrentActionButtons } from '../DailyrentActionButtons/DailyrentActionButtons';

interface IProps {
  offerId: number;
  position: number;
}

export const ContactButtonsContainer = ({ offerId, position }: IProps) => {
  const offer = useSelector(selectRecommendationById(offerId));
  const { url = '', dealRentEnabled, dailyrent } = offer || {};

  const isRenterFormEnabledFlag = useSelector(isRenterFormEnabled);
  const isDailyrentOnlineBookingEnabled = useIsDailyrentOnlineBookingEnabled();

  const onFillFormClick = React.useCallback(() => {
    trackSafeRentFillFormClick(offerId);
  }, [offerId]);

  if (dailyrent?.actionType && isDailyrentOnlineBookingEnabled) {
    return <DailyrentActionButtons offer={offer} position={position} />;
  }

  if (isRenterFormEnabledFlag && dealRentEnabled) {
    return <FillFormButtonMobile onClick={onFillFormClick} href={url} />;
  }

  return <CardActionsContainer offerId={offerId} />;
};
